import { createRoute, useNavigate } from "@tanstack/react-router";
import { ReviewDesk, ReviewScriptList } from "@/features/review";
import { rootRoute } from "./root";

export const reviewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/review",
  component: function Review() {
    const navigate = useNavigate();
    return (
      <ReviewDesk>
        <ReviewScriptList
          onOpenScript={scriptId => navigate({ to: "/review/$scriptId", params: { scriptId } })}
          onOpenLeaderboard={() => navigate({ to: "/review/leaderboard" })}
          onOpenDevices={() => navigate({ to: "/review/devices" })}
          onBack={() => navigate({ to: "/" })}
        />
      </ReviewDesk>
    );
  },
});
